export default __webpack_public_path__ + "static/media/Giftr-Logo-Main.63f3b594.svg";